import * as types from "../../constants/index"

export default {
  state: {
    screenBoxStatus:false
  },
  mutations:{
    [types.SCREEN_STATUS](state, payload) {
      state.screenBoxStatus = payload
    },
  },
  getters: {
    screenBoxStatus: state => state.screenBoxStatus,
  }
}
